import request from '../../../util/SuperagentUtils';
import { buyerInventoryReportEndpoints, supplierCurrentInventoryReportEndpoints } from '../../../requests/api-endpoints';
import { getSupplierInterchanges } from '../../interchanges/requests/supplier-interchanges-requests';
import { getBuyerInterChanges } from '../../interchanges/requests/buyer-interchanges-requests';

export interface SupplierCheckoutLookupRow {
  activity?: string;
  activityDate?: string;
  locationName?: string;
  orderNumber?: string;
  containerNumber?: string;
  trailerNumber?: string;
  chassisNumber?: string;
}

export interface SupplierCurrentInventoryLookupRow {
  checkInDate?: string;
  locationName?: string;
  orderNumber?: string;
  containerNumber?: string;
  trailerNumber?: string;
  chassisNumber?: string;
}

export const searchSupplierCheckoutHistory = async (
  equipmentNumber: string,
): Promise<SupplierCheckoutLookupRow[]> => {
  const response = await getSupplierInterchanges({
    equipmentNumber,
    activity: 'CHECK_OUT',
    sortBy: 'ACTIVITY_DATE',
    sortDir: 'desc',
    page: '0',
    size: '10',
    isPageable: true,
  });

  return response?.body?.content ?? [];
};

export const searchSupplierCurrentInventory = async (
  equipmentNumber: string,
): Promise<SupplierCurrentInventoryLookupRow[]> => {
  const params = new URLSearchParams({
    equipmentNumber,
    page: '0',
    size: '10',
    sortBy: 'CHECK_IN_DATE',
    sortDir: 'desc',
  });
  const response = await request.get(
    `${supplierCurrentInventoryReportEndpoints.search}?${params.toString()}`,
  );
  return response?.body?.content ?? [];
};

/**
 * Buyer interchanges don't support server-side filtering by activity, so we
 * pull a generous page of this equipment's most recent activity and filter
 * for CHECK_OUT rows client-side. Sized well above what one piece of
 * equipment would realistically rack up between checkouts, so an older
 * CHECK_OUT is not missed behind a run of other activity (corrections,
 * repeated check-ins, etc.) on the same equipment number.
 */
export const searchBuyerCheckoutHistory = async (
  equipmentNumber: string,
): Promise<SupplierCheckoutLookupRow[]> => {
  const response = await getBuyerInterChanges({
    equipmentNumber,
    sortBy: 'ACTIVITY_DATE',
    sortDir: 'desc',
    page: 0,
    size: 100,
  });

  const rows: SupplierCheckoutLookupRow[] = response?.body?.content ?? [];
  return rows.filter((row) => row.activity === 'CHECK_OUT');
};

export const searchBuyerCurrentInventory = async (
  equipmentNumber: string,
): Promise<SupplierCurrentInventoryLookupRow[]> => {
  const params = new URLSearchParams({
    equipmentNumber,
    page: '0',
    size: '10',
    sortBy: 'CHECK_IN_DATE',
    sortDir: 'desc',
  });
  const response = await request.get(
    `${buyerInventoryReportEndpoints.search}?${params.toString()}`,
  );
  return response?.body?.content ?? [];
};
